import app from '@/app';

/* @ngInject */
function Grip($resource) {
	return $resource(
		'api/grips/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Grip', Grip);
